import React, { ReactNode, SyntheticEvent } from 'react';

import SOCIAL from '../../constants/social';
import isMobile from '../../utils/isMobile';
import { withTrack, WithTrack } from '../../utils/analytics';

// TODO social_utm_term on all social tracking? campaign does it?

export type MessengerShareProps = WithTrack & {
  children: ReactNode;
  url: string;
  className?: string;
  trackingData: Record<string, any>;
};

export class MessengerShare extends React.PureComponent<MessengerShareProps> {
  onClick = (event: SyntheticEvent) => {
    const { track, trackingData } = this.props;
    track(trackingData);

    if (!isMobile(window)) {
      event.preventDefault();
      FB.ui(
        {
          method: 'send',
          link: this.props.url,
        },
        () => {},
      );
    }
  };

  render() {
    const { children, className, url } = this.props;

    return (
      <a
        data-qa="messenger-btn"
        onClick={this.onClick}
        className={`jg-btn jg-btn--messenger ${className}`}
        href={`fb-messenger://share/?link=${url}&app_id=${SOCIAL.FB_APP_ID}`}
      >
        {children}
      </a>
    );
  }
}

export default withTrack(MessengerShare);
